<template>
  <v-app>
    <v-container class="pa-0 ma-0">
      <v-overlay
        :value="true"
        opacity="1"
        z-index="200"
        color="primary"
        style="text-align: center"
      >
        <v-progress-circular width="10" size="110" color="white" indeterminate>
          <Logo
            product="conecta_suite"
            height="55"
            noMargins
            white
            class="blink"
          />
        </v-progress-circular>
        <transition
          v-for="(message, index) in messages"
          :key="`loading-${index}`"
          name="fade-transition"
          mode="out-in"
        >
          <div
            :key="message"
            v-html="message || 'Carregando...'"
            class="text-h6 font-weight-regular pt-6"
          />
        </transition>
      </v-overlay>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: "PageLoading",

  props: {
    messages: { type: Array, default: () => [""] },
  },
};
</script>
